/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserListItem
 */
export interface MelcoModelsUserListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    last_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    country_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    state_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    account_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsUserListItem
     */
    is_email?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    parent_user_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    business_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserListItem
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserListItem
     */
    created_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserListItem
     */
    verified_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserListItem
     */
    last_login_date?: Date | null;
}

export function MelcoModelsUserListItemFromJSON(json: any): MelcoModelsUserListItem {
    return MelcoModelsUserListItemFromJSONTyped(json, false);
}

export function MelcoModelsUserListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
        'state_code': !exists(json, 'state_code') ? undefined : json['state_code'],
        'account_name': !exists(json, 'account_name') ? undefined : json['account_name'],
        'is_email': !exists(json, 'is_email') ? undefined : json['is_email'],
        'parent_user_id': !exists(json, 'parent_user_id') ? undefined : json['parent_user_id'],
        'business_name': !exists(json, 'business_name') ? undefined : json['business_name'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'created_on': !exists(json, 'created_on') ? undefined : (new Date(json['created_on'])),
        'verified_on': !exists(json, 'verified_on') ? undefined : (new Date(json['verified_on'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'last_login_date': !exists(json, 'last_login_date') ? undefined : (json['last_login_date'] === null ? null : new Date(json['last_login_date'])),
    };
}

export function MelcoModelsUserListItemToJSON(value?: MelcoModelsUserListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'user_name': value.user_name,
        'email': value.email,
        'country_code': value.country_code,
        'state_code': value.state_code,
        'account_name': value.account_name,
        'is_email': value.is_email,
        'parent_user_id': value.parent_user_id,
        'business_name': value.business_name,
        'melco_customer_id': value.melco_customer_id,
        'created_on': value.created_on === undefined ? undefined : (value.created_on.toISOString()),
        'verified_on': value.verified_on === undefined ? undefined : (value.verified_on.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'last_login_date': value.last_login_date === undefined ? undefined : (value.last_login_date === null ? null : value.last_login_date.toISOString()),
    };
}


